import { useMemo } from 'react';

import Letter from './Letter';
import LetterContainer from './LetterContainer';
import { LetterProvider } from './LetterContext';

const LetterShell = ({
  topSlot,
  showPhaseChips,
  view,
  mode,
  config,
  activePhaseField,
  balance,
  totalAmount,
  amounts,
  activePaymentMethod,
  setActivePaymentMethod,
  appointment,
  practiceId,
  patientId,
  patientName,
  secureTokenId,
  onCancelPreAuth,
  timezone,
  patient
}) => {
  const ctxValue = useMemo(
    () => ({
      view,
      mode,
      config,
      activePhaseField,
      balance,
      totalAmount,
      amounts,
      activePaymentMethod,
      setActivePaymentMethod,
      appointment,
      practiceId,
      patientId,
      patientName,
      secureTokenId,
      onCancelPreAuth,
      timezone,
      patient
    }),
    [
      view,
      mode,
      config,
      activePhaseField,
      balance,
      totalAmount,
      amounts,
      activePaymentMethod,
      setActivePaymentMethod,
      appointment,
      practiceId,
      patientId,
      patientName,
      secureTokenId,
      onCancelPreAuth,
      timezone,
      patient
    ]
  );

  return (
    <LetterProvider value={ctxValue}>
      <LetterContainer
        topSlot={topSlot}
        showPhaseChips={showPhaseChips}
        fullWidth={mode === 'interactive'}>
        <Letter />
      </LetterContainer>
    </LetterProvider>
  );
};

export default LetterShell;
